import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2'

const axiosBase = axios.create({
  'baseURL': process.env.HOSTAPI,
  'headers': {
    'API_KEY': 'dD217e611c616ac374d2ac1150',
    'Content-Type': 'application/x-www-form-urlencoded',
    'token': localStorage.getItem('token')
  }
})

axiosBase.interceptors.response.use(
  (response) => {
    // Modify response data if needed
    return response
  },
  (error) => {
    if (error.response) {
      console.error('Error Response:', error.response)
    }
    if (error.request) {
      console.error('Error Request:', error.request)
    }

    // Handle error responses globally
    if (error.response.status === 401) {
      Swal.fire({
        title: 'Session',
        text: 'Timeout',
        type: 'error',
        showCancelButton: false,
        confirmButtonText: 'Login',
        backdrop: true,
        allowOutsideClick: false
      }).then(res => {
        if (res.value) {
          setTimeout(() => {
            console.log('this')
            localStorage.clear()
            window.location.href = process.env.templogoutredirect + `/login`
          }, 2000)
        }
      })
    }
    return Promise.reject(error)
  }
)
export default axiosBase

// dev//5tfaszcgh5Egfy3671g32hcnhMn

// pro//dD217e611c616ac374d2ac1150



// WEBPACK FOOTER //
// ./src/axios/index.js